import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import styles from '@features/navigation/components/MegaMenuDesktop/MegaMenuDesktop.styles';
import stylesMobile from '@features/navigation/components/MegaMenuMobile/MegaMenuMobile.styles';
import { BehaviourType, TCategoriesTree, TServiceMap } from '@features/categories/typescript';
import useCategoryArray from '@hooks/useCategoryArray';
import { ICategory } from '@features/categories';
import ProductsItem from '@features/navigation/components/ProductsItem/ProductsItem';
import { TImage } from '@components/typescript';
type PropsType = {
  products: TCategoriesTree;
  isMobile: boolean;
  topContent?: React.ReactNode;
  bottomContent?: React.ReactNode;
  serviceMap: TServiceMap;
  onCloseMenu: () => void;
  onHoverProduct?: (file: TImage) => void;
  className?: string;
};
const Products = ({
  products,
  isMobile,
  topContent = undefined,
  bottomContent = undefined,
  serviceMap,
  onCloseMenu,
  className = '',
  onHoverProduct = undefined
}: PropsType) => {
  const [selectedProduct, setSelectedProduct] = useState(0);
  const productsArray = useCategoryArray(products);
  const {
    t
  } = useTranslation('common');
  if (!productsArray.length) {
    return null;
  }
  const columnCollectionList: Array<ICategory> = productsArray.filter((item: ICategory) => item.behaviour === BehaviourType.COLUMN_COLLECTION);
  const columnBrandList: Array<ICategory> = productsArray.filter((item: ICategory) => item.behaviour === BehaviourType.COLUMN_BRAND);
  const columnTypeList: Array<ICategory> = productsArray.filter((item: ICategory) => item.behaviour === BehaviourType.COLUMN_TYPE);
  const otherList: Array<ICategory> = productsArray.filter((item: ICategory) => item.behaviour !== BehaviourType.COLUMN_COLLECTION && item.behaviour !== BehaviourType.COLUMN_BRAND && item.behaviour !== BehaviourType.COLUMN_TYPE);
  const isAnyHeading = columnCollectionList.length > 0 || columnBrandList.length > 0;
  const renderItems = (items: Array<ICategory>, heading?: string) => {
    const chunkSize = 10;
    const lists: [ICategory[]] = [[]];
    for (let i = 0; i < items.length; i += chunkSize) {
      const chunk = items.slice(i, i + chunkSize);
      lists.push(chunk);
    }
    return lists.map((list: ICategory[], index) => {
      if (list.length === 0) {
        return null;
      }
      const withPaddingTop = !!heading && index !== 1 && isAnyHeading || !heading && isAnyHeading;
      return <ul key={Math.random()} sx={isMobile ? stylesMobile.products : styles.products(withPaddingTop)}>
          {index === 1 && !!heading && <div sx={styles.productsHeading}>{heading}</div>}
          {list.map((product: ICategory) => <ProductsItem key={product.id} product={product} serviceMap={serviceMap} onHoverItem={onHoverProduct} onCloseMenu={onCloseMenu} selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct} isMobile={isMobile} />)}
        </ul>;
    });
  };
  return <div className={className ?? ''} sx={isMobile ? stylesMobile.productsContainer : styles.productsContainer}>
      {topContent}
      <div sx={isMobile ? stylesMobile.productMenuContainer : styles.productsContentContainer}>
        {renderItems(otherList)}
        {renderItems(columnTypeList, t('type'))}
        {renderItems(columnBrandList, t('brands'))}
        {renderItems(columnCollectionList, t('voxCollections'))}
      </div>
      {bottomContent}
    </div>;
};
export default Products;